import React from 'react';

import { Button } from '@eventbrite/eds-button';

import { PASSWORD_REQUIRED } from '../../constants';

const PasswordOnlyCTA = ({ ctaText, eventUrl, onCTAClick, eventId }) => (
    <div className="eds-l-mar-top-8">
        <Button
            type="link"
            target="_blank"
            href={eventUrl}
            onClick={onCTAClick.bind(
                null,
                PASSWORD_REQUIRED,
                eventId,
                eventUrl,
            )}
            data-spec="enter-password-cta"
            style="fill"
        >
            {ctaText}
        </Button>
    </div>
);

export default PasswordOnlyCTA;
